import React from 'react';
import { CheckIcon } from '@heroicons/react/20/solid';
import { SelectOption } from '../../interfaces';

export const ComboboxOption: React.FC<{
  option: SelectOption;
  formatOptionLabel?: (option: SelectOption) => React.ReactNode;
}> = ({ option, formatOptionLabel }) => {
  const optionLabel = formatOptionLabel ? formatOptionLabel(option) : option.label;
  return (
    <div className={'flex flex-row justify-between'}>
      <div className={'ui-selected:font-semibold ui-not-selected:font-normal'}>{optionLabel}</div>
      <CheckIcon className="hidden h-5 w-5 ui-selected:block" aria-hidden="true" />
    </div>
  );
};
